import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-common-error-display',
  templateUrl: './common-error-display.component.html',
  styleUrls: ['./common-error-display.component.scss']
})
export class CommonErrorDisplayComponent implements OnInit {

  ngOnInit(): void {
    // Logic to be executed when the component is initialized
    // For example, you can fetch data or perform any setup here
    console.log('CommonErrorDisplayComponent initialized');
    // We can reuse this component for desert screen?
  }

}
